import {SetPostCreateBonuses} from './thunk/postCreateBonuses';
import {SetGetListBonuses} from './thunk/setGetListBonuses';
import {SetGetViewBonuses} from './thunk/setGetViewBonuses';
import {SetPostResultDenomination} from './thunk/setPostResultDenomination';
import {SetPostUpdateBonuses} from './thunk/setPostUpdateBonuses';

export const Thunks = {
    SetPostCreateBonuses,
    SetGetListBonuses,
    SetGetViewBonuses,
    SetPostResultDenomination,
    SetPostUpdateBonuses
}